export enum EDirectionType {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}
